// https://fanduel.atlassian.net/wiki/spaces/FAW/pages/310205907006/Amplitude+Casino+next.js+Web+Migration+-+Home+Page#Game-Favorited
import { getEventPropsBuilder, getJackpotData, toSnakeCase } from '../../utils';
import type { AmplitudeEventKeys } from '../../amplitude-properties.types';
import type { RefObject } from 'react';
import { useStore } from '@/store/store';

export type FavoriteGameEvent = {
    action: 'add' | 'remove';
    module?: string;
    zoneName: string;
    gameName: string;
    position?: number;
    zonePosition?: number;
    gameId: string;
    isSwjGame?: boolean;
};

export const getFavoriteGameProps = getEventPropsBuilder((e: FavoriteGameEvent) => {
    const props: Partial<AmplitudeEventKeys> = {
        event: e.action === 'add' ? 'Game Favorited' : 'Game Favorite Removed',
        Module: toSnakeCase(e.module || '') || 'game_zone',
        'Zone Name': toSnakeCase(e.zoneName),
        'Game Name': toSnakeCase(e.gameName),
        Position: `${!Number.isNaN(+e.position!) ? e.position! + 1 : ''}`,
        'Zone Position': `${!Number.isNaN(+e.zonePosition!) ? e.zonePosition! + 1 : ''}`,
        'Game ID': toSnakeCase(e.gameId)
    };

    if (!e.isSwjGame) {
        return props;
    }

    const jackpotData = getJackpotData(useStore?.getState()?.siteWideJackpot?.updatedTiers);

    return {
        ...props,
        ...jackpotData
    };
});

export const getTrackingData = (buttonRef: RefObject<HTMLElement>) => {
    if (!buttonRef.current) {
        return null;
    }

    const game = buttonRef.current.closest('[data-t-gameuid]');
    const gameUid = game?.getAttribute('data-t-gameuid');
    const gamePosition = game?.getAttribute('data-t-gameposition');
    let gameName = game?.getAttribute('data-t-gamename');
    if (!gameName) {
        // in case of game info page // TODO: refactor game info page
        gameName = buttonRef.current.closest('[data-t-gamename]')?.getAttribute('data-t-gamename');
    }

    const zone = buttonRef.current.closest('[data-t-zoneuid]');
    const zoneUid = zone?.getAttribute('data-t-zoneuid');
    const zonePosition = zone?.getAttribute('data-t-zoneposition');
    let zoneName = zone?.getAttribute('data-t-zonename');

    let zoneModule = buttonRef.current.closest('[data-t-zonemodule]')?.getAttribute('data-t-zonemodule');

    const isCategoryPage = window.location.pathname.startsWith('/c/');
    const isGameInfoPage = window.location.pathname.startsWith('/game/');
    const isGameInfoModal = buttonRef.current.closest('[data-t-gameinfomodal]');

    if (isCategoryPage) {
        zoneModule = 'game_list';
    } else if (isGameInfoPage) {
        zoneModule = 'game_info_cta';
        zoneName = 'game_info_cta';
    } else if (isGameInfoModal) {
        zoneModule = 'game_info_modal';
        zoneName = 'game_info_modal';
    } else {
        zoneModule = buttonRef.current.closest('[data-t-zonemodule]')?.getAttribute('data-t-zonemodule');
        zoneName = zoneModule;
    }

    const isSwjGame = buttonRef.current.closest('[data-t-isswj]')?.getAttribute('data-t-isswj') === 'true';

    return {
        gameUid,
        gamePosition,
        gameName,
        zoneUid,
        zonePosition,
        zoneName,
        module: zoneModule,
        isSwjGame: isSwjGame
    };
};
